
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-label-color, var(--ig-gray-700));--disabled-color: var(--ig-label-disabled-color, var(--ig-gray-500));--ig-theme-variant: light}`;
  